<template>
    <div class="d-flex align-items-center">
        <a :href="printUrl" target="_blank" class="btn btn-sm btn-success mr-2">
            Print
        </a>
        <a :href="downloadUrl" target="_blank" class="btn btn-sm btn-info mr-2">
            PDF
        </a>
        <button type="button" class="btn btn-sm btn-primary mr-2" @click.prevent="editInvoice">
            Edit
        </button>
        <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteInvoice">
            Delete
        </button>
    </div>
</template>

<script>
import { urlGenerator } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "CustomInvoiceAction",
    props: {
        rowData: {
            type: Object,
            required: true
        }
    },
    computed: {
        printUrl() {
            return urlGenerator(`settings/custom-invoices/${this.rowData.id}/print`);
        },
        downloadUrl() {
            return urlGenerator(`settings/custom-invoices/${this.rowData.id}/download`);
        }
    },
    methods: {
        editInvoice() {
            this.$hub.$emit('custom-invoice-edit', this.rowData);
        },
        deleteInvoice() {
            this.$hub.$emit('custom-invoice-delete', this.rowData);
        }
    }
}
</script>

<style scoped>
.btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>
